"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valdidentro": {
    "b6c14adc": [{
      "hkey": "a5754ef2",
      "slug": "isolaccia-piandelvino",
      "name": "Isolaccia-Piandelvino",
      "primary": true,
      "skipSearch": false
    }],
    "isolaccia": [{
      "hkey": "a5754ef2",
      "slug": "isolaccia-piandelvino",
      "name": "Isolaccia-Piandelvino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "146228aa": [{
      "hkey": "85309e41",
      "slug": "semogo-san-carlo",
      "name": "Semogo-San Carlo",
      "primary": true,
      "skipSearch": false
    }],
    "semogo": [{
      "hkey": "85309e41",
      "slug": "semogo-san-carlo",
      "name": "Semogo-San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;